import React, { FC } from "react"

import * as css from "./WithBackground.module.scss"

const WithBackground: FC<any> = ({ className, children }) => {
  return <div className={`${css.wrapper} ${className}`}>{children}</div>
}

export default WithBackground
